// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"1bbf864d","453":"ea2f4e1a","455":"2a61c815"}[chunkId] + ".chunk.js";
};